import { withPopup } from '../lib/popup';

import DueDateEditStep from './DueDateEditStep';

export default withPopup(DueDateEditStep);
